"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppsApi = void 0;
const axios_1 = __importDefault(require("axios"));
class AppsApi {
    constructor() {
        this._baseUrl = 'https://raw.githubusercontent.com/delab-team/apps-data/main/';
    }
    async getItems(selectedLanguage) {
        const url = selectedLanguage === 'ru' ? 'data-ru.json' : 'data-en.json';
        const res = await axios_1.default.get(`${this._baseUrl}${url}`);
        return res.data.data;
    }
}
exports.AppsApi = AppsApi;
